import type { User } from '@/types/auth';

/**
 * Whether the user holds a permission through any of their roles.
 *
 * Mirrors the backend gate: a permission is granted if it appears on at least
 * one of the user's roles, regardless of which role carries it.
 */
export function userHasPermission(
  user: User | undefined,
  permissionName: string
): boolean {
  return !!user?.roles.some((role) =>
    role.permissions?.includes(permissionName)
  );
}
